/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import Primary from './DonutChart.scss';

class DonutChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      optionsRadial: {
        colors: [Primary.DonutChartFillBg],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '40%',
              //background: Primary.DonutChartCircleBg,
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              customScale: 2,
            },

            dataLabels: {
              showOn: 'always',
              value: {
                offsetY: -10,
                color: Primary.DonutChartTextColor,
                fontSize: '12px',
                show: true,
              },
            },
          },
        },
        fill: {
          type: 'solid',
        },
        stroke: {
          lineCap: '',
        },
        labels: [''],
      },
    };
  }

  render() {
    const self = this.state;
    const { seriesRadial, chartType } = this.props;
    return (
      <Chart
        className="chart-radio"
        options={self.optionsRadial}
        series={seriesRadial}
        type={chartType}
      />
    );
  }
}

export default DonutChart;
